import type { TextareaHTMLAttributes } from 'react';
import { cx } from '../lib/cx';
import { Field, borderClass, controlClass } from './Field';

export interface TextareaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'id'> {
  id: string;
  label?: string;
  hint?: string;
  error?: string | undefined;
}

export function Textarea({ id, label, hint, error, className, required, ...rest }: TextareaProps) {
  return (
    <Field id={id} label={label} hint={hint} error={error} required={required}>
      <textarea
        id={id}
        rows={rest.rows ?? 4}
        /*
          Zvjezdica uz natpis vidi se okom; čitač zaslona je ne pročita.
          Bez ovoga je obavezno polje za njega izgledalo jednako kao i ostala.
        */
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
        className={cx(controlClass, borderClass(!!error), 'resize-y', className)}
        {...rest}
      />
    </Field>
  );
}
